module.exports = __webpack_public_path__ + "img/ziliao1.4f09990c.png";